var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap p_b50",class:{ dark: this.color }},[_c('div',{staticClass:"modal_wrap"},[_c('router-view'),_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }